import { Calendar, ArrowDown } from "lucide-react";
import { Button } from "../ui/button";

export function NoFeaturedRace() {

    const scrollToCalendar = () => {
        const calendarSection = document.getElementById('race-calendar');
        if (calendarSection) {
            calendarSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <section className="min-h-screen flex flex-col">
            <div className="flex-1 grid md:grid-cols-2 gap-4 px-6">
                <div className="flex flex-col justify-center">
                    <div className="mb-12">
                        <div className="relative">
                            <div className="absolute -left-4 top-0 w-2 h-24 bg-slate-700" />
                            <h1 className="text-4xl md:text-7xl font-light tracking-tighter leading-tight mb-4">
                                NÄCHSTES<br />
                                <span className="text-slate-700">SKIRENNEN</span>
                            </h1>
                            <div className="mt-8 text-lg text-slate-600 leading-relaxed">
                                Aktuell sind keine Rennen zur Anmeldung ausgeschrieben.
                                Die neue Saison beginnt im November - schauen Sie bald wieder vorbei!
                            </div>
                            <div className="grid grid-cols-2 gap-8 mt-8">
                                <div>
                                    <div className="text-sm tracking-widest text-slate-600 mb-2">SAISONSTART</div>
                                    <div className="text-lg">1. November</div>
                                </div>
                                <div>
                                    <div className="text-sm tracking-widest text-slate-600 mb-2">SAISONENDE</div>
                                    <div className="text-lg">31. März</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Button
                        variant="outline"
                        className="w-fit px-8 py-6 border-slate-200 hover:bg-slate-50 font-light tracking-wider"
                        onClick={scrollToCalendar}
                    >
                        <Calendar className="mr-2 h-5 w-5" />
                        RENNKALENDER ANSEHEN
                    </Button>
                </div>
                <div className="hidden md:flex md:items-center md:justify-center">
                    <div className="relative w-full aspect-square max-w-lg">
                        <div className="absolute inset-0 bg-slate-100 rounded-full opacity-20" />
                        <div className="absolute inset-8 bg-slate-100 rounded-full opacity-40" />
                        <div className="absolute inset-16 bg-slate-100 rounded-full opacity-60" />
                        <div className="absolute inset-24 bg-slate-100 rounded-full opacity-80" />
                        <div className="absolute inset-32 bg-slate-100 rounded-full" />
                    </div>
                </div>
            </div>
            <div className="p-6 flex justify-center">
                <ArrowDown className="animate-bounce text-slate-600 md:h-10 md:w-10" />
            </div>
        </section>
    );
}
